import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "../../assets/css/HeroBanner.css";


import precImg from "../../assets/images/pretwo.webp";
import bioImg from "../../assets/images/bioone.webp";
import distImg from "../../assets/images/indone.webp";



/* Banner data */
const banners = [
  {
    title: "Precision Fermentation",
    subtitle: "Solutions for India's Leading Distilleries",
    image: precImg,
  },
  {
    title: "Biological Catalyst",
    subtitle: "Designed to optimize the Ethanol Yeild ",
    image: bioImg,
  },
  {
    title: "Distillery Excellence",
    subtitle: "Delivering Pan India",
    image: distImg,
  },
];

function HeroBanner() {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  };

  return (
    <section className="energo-hero-carousel">
      <Slider {...settings}>
        {banners.map((item, index) => (
          <div key={index}>
            <div
              className="energo-hero-slide container-fluid"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="container-fluid px-lg-5">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-8 hero-content">
                    <h1>
                      {item.title}
                      <span>{item.subtitle}</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default HeroBanner;
